import { useFeatureFlags } from '@/src/context/FeatureFlagContext'
import { ReactNode } from 'react'

interface FeatureGateProps {
  feature: string
  children: ReactNode
  fallback?: ReactNode
}

export const FeatureGate = ({ feature, children, fallback = null }: FeatureGateProps) => {
  const { flags, isLoading } = useFeatureFlags()
  if (isLoading) return null
  return flags[feature] ? <>{children}</> : <>{fallback}</>
}
